import React from 'react';
const MicrowaveIcon = () => (
    <svg width="45" height="32" viewBox="0 0 99 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="1.14102"
            y="1"
            width="96.7179"
            height="63.5128"
            rx="5"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="8.32051"
            y="8.17944"
            width="66.2051"
            height="49.1538"
            rx="5"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <path
            d="M90.6795 18.8462C90.6795 21.2677 88.7164 23.2308 86.2949 23.2308C83.8733 23.2308 81.9103 21.2677 81.9103 18.8462C81.9103 16.4246 83.8733 14.4615 86.2949 14.4615C88.7164 14.4615 90.6795 16.4246 90.6795 18.8462Z"
            stroke="black"
            strokeWidth="2"
        />
        <path
            d="M90.6795 33.2052C90.6795 35.6267 88.7164 37.5898 86.2949 37.5898C83.8733 37.5898 81.9103 35.6267 81.9103 33.2052C81.9103 30.7836 83.8733 28.8206 86.2949 28.8206C88.7164 28.8206 90.6795 30.7836 90.6795 33.2052Z"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="81.9103"
            y="49.4615"
            width="8.76923"
            height="6.07692"
            rx="1"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="80.1154"
            y="64.7179"
            width="10.5641"
            height="4.28205"
            rx="1"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="8.32051"
            y="64.7179"
            width="10.5641"
            height="4.28205"
            rx="1"
            stroke="black"
            strokeWidth="2"
        />
        <path
            d="M32.4751 18.8462C32.4751 18.8462 29.3077 21.9689 29.3077 26.2271C29.3077 30.4854 33.7949 35.0275 33.7949 39.5696C33.7949 44.1118 31.4193 46.6667 31.4193 46.6667"
            stroke="#32AE57"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M42.3469 18.8462C42.3469 18.8462 39.1795 21.9689 39.1795 26.2271C39.1795 30.4854 43.6667 35.0275 43.6667 39.5696C43.6667 44.1118 41.2911 46.6667 41.2911 46.6667"
            stroke="#32AE57"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M52.2187 18.8462C52.2187 18.8462 49.0513 21.9689 49.0513 26.2271C49.0513 30.4854 53.5385 35.0275 53.5385 39.5696C53.5385 44.1118 51.1629 46.6667 51.1629 46.6667"
            stroke="#32AE57"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default MicrowaveIcon;



// WEBPACK FOOTER //
// ./src/components/icons/MicrowaveIcon.js